import { AlphaSCircleOutlineIcon } from './AlphaSCircleOutlineIcon';

/**
 * author: Contributors
 * id 17018533-C274-4E75-86DB-2D0DB1F4B45E
 * name alpha-s-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-s-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterSCircleOutlineIcon = AlphaSCircleOutlineIcon;
export default LetterSCircleOutlineIcon